import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { S as u } from "./styled-box-DJEn6F3U.mjs";
import { F as g } from "./flex-Cc3osQLf.mjs";
import { I as f } from "./icon-v2-DGtVEk7e.mjs";
import { m as x } from "./tss-DN0acMKN.mjs";
import { B as h } from "./body-text-BiQwh5-U.mjs";
import { D as j } from "./divider-Dq5lrAFK.mjs";
const w = x()((s, n) => {
  const {
    borderRadiuses: e,
    spacing: o,
    constructs: { surface: l, text: a },
    typography: t
  } = s, { active: i, completed: c } = n;
  return {
    root: {
      alignItems: "center",
      backgroundColor: i ? l.neutral.xWeak : "transparent",
      borderRadius: e[400],
      display: "flex",
      gap: o(1.5),
      overflow: "hidden",
      padding: `${o(2)} ${o(2.5)}`
    },
    stepLabel: {
      color: i || c ? a.primary.strong : a.neutral.strong,
      fontSize: t.large.fontSize,
      fontWeight: i ? t.fontWeightBold : t.fontWeightMedium,
      lineHeight: t.large.lineHeight,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  };
});
function b({ stepNumber: s, name: n, active: e, completed: o, ariaLabel: l }) {
  const { classes: a } = w({ active: e, completed: o }), t = o ? "circle-check-solid" : `circle-${s}-${e ? "solid" : "regular"}`;
  return /* @__PURE__ */ r.jsxs("li", { "aria-label": l, className: a.root, children: [
    /* @__PURE__ */ r.jsx(f, { color: e || o ? "primary-strong" : "neutral-extra-strong", name: t, size: 24 }),
    /* @__PURE__ */ r.jsx("p", { className: a.stepLabel, children: n })
  ] });
}
function _(s) {
  var i;
  const { currentStep: n, steps: e, tabOverflowLimit: o } = s;
  function l(c, p) {
    return c > p ? window.jQuery ? $.__("Completed step") : "Completed step" : c === p ? window.jQuery ? $.__("Current step") : "Current step" : window.jQuery ? $.__("Pending step") : "Pending step";
  }
  function a() {
    return Object.entries(e).splice(0, 9).map(([p, m]) => {
      const d = parseInt(p, 10);
      return /* @__PURE__ */ r.jsx(
        b,
        {
          active: n === d,
          ariaLabel: l(n, d),
          completed: n > d,
          name: m.name,
          stepNumber: d
        },
        d
      );
    });
  }
  const t = (i = e == null ? void 0 : e[n]) == null ? void 0 : i.note;
  return /* @__PURE__ */ r.jsxs(
    u,
    {
      backgroundColor: "neutral-weak",
      borderRadius: "large",
      boxShadow: "large",
      "data-fabric-component": "Wizard",
      paddingX: 4,
      paddingY: 2,
      children: [
        /* @__PURE__ */ r.jsx(g, { alignItems: "center", component: "ul", gap: 2, children: a() }),
        t && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(j, { color: "neutral-weak", marginBottom: 2.5, marginTop: 2 }),
          /* @__PURE__ */ r.jsx(h, { color: "neutral-extra-strong", size: "medium", children: t })
        ] })
      ]
    }
  );
}
export {
  _ as W
};
//# sourceMappingURL=wizard-Biu_V5vg.mjs.map
